module.exports = __webpack_public_path__ + "static/screenshot-single-d93dd31d8635aacc38455dbff9de3347.png";